import React, { useContext, useState } from "react";
import { Button } from "react-bootstrap";
import { EditorContext } from "../EditorCommon/EditorContext";
import { MaterialSelectorModal } from "../EditorCommon/MaterialSelectorModal";
import { GableMover } from "./GableMover";
import { InteriorDragContext } from "./InteriorImageDragContext";
import "./InteriorItemEditor.scss"
import { ProductDebugInfo } from "./ProductDebugInfo";

export function InteriorItemEditor(props: {

}) {

    const ec = useContext(EditorContext);
    const dragContext = useContext(InteriorDragContext);
    const [isMaterialModalOpen, setIsMaterialModalOpen] = useState(false);

    const item = dragContext.info?.item;
    if (!item)
        return null;

    const product = ec.cabinetService.interior.getProduct(item.productId);

    const itemIndex = item.index;

    function deleteItem() {
        ec.cabinetService.interior.deleteItem(itemIndex);
        dragContext.setInfo(undefined);
    }

    const isViolatingPullout = ec.cabinetService.interior
        .getPulloutViolations()
        .indexOf(item) >= 0;

    const isMountedOnWall = ec.cabinetService.interior
        .isMountedOnWall(item);

    const isExceedingBounds = ec.cabinetService.interior
        .isExceedingBounds(item);

    const material = product.materials.find(m => m.interiorMaterialId === item.interiorMaterialId);
    const imageUrl = material?.picturePath ?? product.productSubGroup.imageUrl;
    const canSelectMaterials = product.materials.length > 1;

    function openMaterialSelector() {
        if (!canSelectMaterials)
            return;
        setIsMaterialModalOpen(true);
    }

    function setMaterial(matId: number) {
        ec.cabinetService.interior.setItemMaterial(item!.index, matId);
        setIsMaterialModalOpen(false);
    }

    const selectableMaterials = product.materials.map(m => ({
        id: m.interiorMaterialId,
        name: m.name,
        sampleImageUrl: m.picturePath
            ?? ec.cabinetService.chainInfo.interiorMaterials.find(im => im.id === m.interiorMaterialId)?.sampleImageUrl
            ?? null,
        textureImageUrl: m.drawingPath,
    }));

    const materialSelectorModal = isMaterialModalOpen
        && (
            <MaterialSelectorModal
                onClose={() => setIsMaterialModalOpen(false)}
                onSelect={m => setMaterial(m.id)}
                currentId={item.interiorMaterialId ?? undefined}
                materials={selectableMaterials}
            />
        );


    return (
        <div className="interior-item-editor">
            <h3>{product.productSubGroup.name}</h3>

            <div className="card" onClick={openMaterialSelector} style={{ cursor: canSelectMaterials ? "pointer" : undefined }}>
                {imageUrl && <img className="card-img-top" alt="" src={imageUrl} />}
                <div className="card-body">
                    <h5 className="card-title">{product.name}</h5>
                </div>
            </div>


            {isViolatingPullout && <div className="alert alert-warning" role="alert" >
                {ec.translator(
                    "interior item pullout violation warninng",
                    "Skuffen kan ikke åbnes, da døren er i vejen.")}
            </div>}

            {isMountedOnWall && (
                <div className="alert alert-warning" role="alert">
                    {ec.translator(
                        "interior item mall mount violation warning",
                        "Produktet bør ikke monteres direkte på en væg. Sæt eventuelt en gavl op mod væggen.")}
                </div>

            )}

            {isExceedingBounds && (
                <div className="alert alert-warning" role="alert">
                    {ec.translator(
                        "interior item warning exceeds bounds",
                        "Varen er placeret udenfor skabet. Flyt varen, så den er inde i skabet.")}
                </div>

            )}

            <div className="spacer" />
            <Button variant="outline-danger btn-block"
                onClick={deleteItem}
            >
                {ec.translator("interior item editor delete item", "Fjern")}
            </Button>
            <div className="spacer" />
            <GableMover />

            <ProductDebugInfo product={product} material={material} />


            {materialSelectorModal}
        </div>
    );
}
